import { apiOrderCommunicationBooking } from '#store/apiOrderCommunicationBooking.ts';

import { type ScopedBookings, scopedBookingsSchema } from './model/scopedBookings.ts';

export const orderCommunicationBookingSlice = apiOrderCommunicationBooking.injectEndpoints({
    endpoints: build => ({
        getScopedBookings: build.query<ScopedBookings, { asset_id: string }>({
            query: params => ({
                url: '/bookings',
                params,
            }),
            transformResponse: response => scopedBookingsSchema.parse(response),
        }),
    }),
});

export const { useGetScopedBookingsQuery } = orderCommunicationBookingSlice;
